import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Cookies from 'universal-cookie';
import { getTime } from 'date-fns';
import { makeStyles } from '@material-ui/core/styles';
import { Checkbox, Box } from '@material-ui/core';
import DialogContentText from '@material-ui/core/DialogContentText';
import { useParams, useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import CustomTable from '../../components/Table/Table';
import Button from '../../components/Button/CustomButton';
import {
    LoadMoreIcon,
    RadioButtonIcon,
} from '../../components/Icons/Icon';
import styles from '../../assets/jss/pages/productManagementPageStyle';
import CustomTypography from '../../components/Typography/CustomTypography';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import dateUtils from '../../utils/dateUtils';
import { navyColor } from '../../assets/jss/global';
import RegisterLinks from '../../components/RegisterLinks/RegisterLinks';
import { LIVESTREAM_STATUS_TEXT } from '../../common/Constants';
import FreeLogin from '../../components/FreeEntrance/FreeLogin';
import AlertDialog from '../../components/Dialog/AlertDialog';
import Snackbar from '../../components/Snackbar/Snackbar';
import ConfirmDialog from '../../components/Dialog/ConfirmDialog';
import Loader from '../../components/Loader/Loader';
import ViewHeader from '../../components/Header/ViewHeader';
import LivestreamPayment from './LivestreamPayment';
import ListLiveStreamViewerCustomLayout from './ListLiveStreamViewerCustomLayout';
import { platform, PLATFORM } from '../../utils/getPlatform';

export const Header = (props) => {
    const { eventInfo } = props;
    const intl = useIntl();

    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <ViewHeader
                    eventName={eventInfo.name}
                    title={eventInfo?.settings_texts_sidebar_viewer?.field_name?.livestreaming || intl.formatMessage({ id: 'userRoutes.liveStream' })}
                    eventInfo={eventInfo}
                />
            )}
        </>
    );
};

Header.defaultProps = {
    eventInfo: {},
};

Header.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

const useStyles = makeStyles(styles);

const ListLiveStreamViewer = (props) => {
    const {
        isLoading,
        listEvent,
        listDate,
        currentPage,
        totalPage,
        fetchViewerGetListLiveStream,
        fetchViewerClearGetListLiveStream,
        eventInfo,
        loggedIn,
        isWeakAuth,
        isCheckEvent,
        registerStatus,
        idRegister,
        viewerRegisterLiveStream,
        clearRegisterLiveStream,
        errorRegister,
        fetchViewerGetListLiveStreamLoginAcc,
        ClearViewerGetListLiveStreamLoginAcc,
        customText,
        customColor,
        errorRegisterLivestream,
        locale,
    } = props;
    const classes = useStyles(props);
    const routeParams = useParams();
    const { shortName } = useParams();
    const history = useHistory();
    const intl = useIntl();

    const isRegisterLivestreamAfter3day = () => {
        const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
        const timeRunningStart = new Date(`${eventInfo.sdate}`);
        const dateEventLivestreamView = utcDateNow < new Date(timeRunningStart.setDate(timeRunningStart.getDate() - 3));
        return dateEventLivestreamView;
    };

    const isRegisterLivestreamViewNew = (date, timeStartLivestream) => {
        const yearStart = +date.split('-')[0];
        const mouthStart = +date.split('-')[1];
        const dayStart = +date.split('-')[2];
        const hourStart = +timeStartLivestream.split(':')[0];
        const minutesStart = +timeStartLivestream.split(':')[1];
        const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
        const currentTime = getTime(new Date(utcDateNow.getFullYear(), utcDateNow.getMonth() + 1, utcDateNow.getDate(), utcDateNow.getHours(), utcDateNow.getMinutes()));
        const timeRunningStart = getTime(new Date(yearStart, mouthStart, dayStart, hourStart - 1, minutesStart));
        const dateEventLivestreamView = timeRunningStart > currentTime;
        return dateEventLivestreamView;
    };

    const handleSearchWithPage = () => {
        if (!eventInfo.free_live_stream && loggedIn && (!isWeakAuth || isWeakAuth === 'false')) {
            fetchViewerGetListLiveStreamLoginAcc({
                event_name: routeParams.shortName,
                page: currentPage + 1,
                language: locale,
            });
        } else {
            fetchViewerGetListLiveStream({
                event_name: routeParams.shortName,
                page: currentPage + 1,
                language: locale,
            });
        }
    };

    const [listEventLiveStream, setListEventLiveStream] = useState({});
    const [registerCheck, setRegisterCheck] = useState({});
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });
    const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState({ open: false, content: '' });
    const [isOpenConfirmSuccess, setIsOpenConfirmSuccess] = useState({ open: false, content: '', success: false });
    const [openDialogDetail, setOpenDialogDetail] = useState(false);
    const [params, setParams] = useState({});

    useEffect(() => {
        fetchViewerClearGetListLiveStream();
        clearRegisterLiveStream();
        ClearViewerGetListLiveStreamLoginAcc();
        return () => {
            fetchViewerClearGetListLiveStream();
            clearRegisterLiveStream();
            ClearViewerGetListLiveStreamLoginAcc();
        };
    }, []);

    useEffect(() => {
        if (shortName && !_.isEmpty(eventInfo)) {
            if (!eventInfo.free_live_stream && loggedIn && (!isWeakAuth || isWeakAuth === 'false')) {
                fetchViewerGetListLiveStreamLoginAcc({ event_name: routeParams.shortName, page: 1, language: locale });
            } else {
                fetchViewerGetListLiveStream({
                    event_name: routeParams.shortName,
                    page: 1,
                    language: locale,
                });
            }
        }
    }, [shortName, eventInfo, locale]);

    useEffect(() => {
        if (listEvent) {
            setListEventLiveStream(listDate);
        }
    }, [listDate]);

    useEffect(() => {
        if (!_.isEmpty(idRegister)) {
            if (!registerStatus) {
                if (errorRegister?.time_error && +params.payment_method === 1) {
                    setIsOpenConfirmSuccess({ open: true, content: intl.formatMessage({ id: 'livestream.oneDayLimitPayment' }), success: false });
                } else if (errorRegister?.time_error && +params.payment_method === 2) {
                    setIsOpenConfirmSuccess({ open: true, content: intl.formatMessage({ id: 'livestream.threeDayLimitPayment' }), success: false });
                } else {
                    setSnackbar({
                        isOpen: true,
                        type: 'error',
                        message: intl.formatMessage({ id: 'seminar.errorRegisterLivestream' }, {
                            namePage: eventInfo.settings_texts_sidebar_viewer?.field_name?.livestreaming
                            || intl.formatMessage({ id: 'userRouters.liveStream' }).toLocaleLowerCase(),
                        }),
                    });
                }
            }
            if (registerStatus && !getRegisterCost()) {
                setIsOpenConfirmSuccess({ open: true, content: intl.formatMessage({ id: 'common.completeApplication' }), success: true });
            } else if (registerStatus && params.payment_method && getRegisterCost()) {
                handleCloseDialogDetail();
                if (+params.payment_method === 1) {
                    setIsOpenConfirmSuccess({
                        open: true,
                        content: intl.formatMessage({ id: 'common.completeApplication' }),
                        success: true,
                    });
                } else if (+params.payment_method === 2) {
                    setIsOpenConfirmSuccess({
                        open: true,
                        content: getContent(),
                        success: true,
                    });
                }
            }
        }
    }, [idRegister]);

    useEffect(() => {
        if (!_.isEmpty(errorRegisterLivestream)) {
            setIsOpenConfirmSuccess({
                open: true,
                content: errorRegisterLivestream?.message.message,
                success: false,
            });
        }
    }, [errorRegisterLivestream]);

    const getContent = () => (
        <>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>
                {intl.formatMessage({ id: 'common.completeApplication' })}
            </DialogContentText>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>
                {intl.formatMessage({ id: 'common.emailBillDetail' })}
            </DialogContentText>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>
                {intl.formatMessage({ id: 'common.confirm' })}
            </DialogContentText>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>
                {intl.formatMessage({ id: 'common.sendMoney' })}
            </DialogContentText>
        </>
    );

    const createDataView = () => {
        const viewTotal = [];
        (Object.keys(listEventLiveStream).forEach((key) => {
            createDateTitle(key);
            const viewTable = [];
            let tableData = [];
            if (loggedIn && eventInfo.free_live_stream) {
                tableData = Object.keys(listEventLiveStream[key]).map((index) => {
                    const liveStream = listEventLiveStream[key][index];
                    return [
                        `${liveStream.stime}~${liveStream.etime}`,
                        liveStream.title,
                        liveStream.content,
                        liveStream.speaker,
                        liveStream.cost === 0
                            ? intl.formatMessage({ id: 'Free' })
                            : `${intl.formatNumber(liveStream.cost)}${intl.formatMessage({ id: 'common.yen' })}`,
                        liveStream.status === 3 && (
                            <Button
                                onClick={(e) => onViewLiveStream(e, liveStream.id)}
                                color="navy"
                                style={{ fontSize: '14px' }}
                                buttonTextColor={customColor?.button_text_color}
                                buttonBackgroundColor={customColor?.button_background_color?.common_button}
                            >
                                {customText?.button_name?.watch_livestream || intl.formatMessage({ id: 'livestream.watchLivestream' })}
                            </Button>
                        ),
                    ];
                });
            } else if (loggedIn && (!isWeakAuth || isWeakAuth === 'false') && !eventInfo.free_live_stream) {
                tableData = Object.keys(listEventLiveStream[key]).map((index) => {
                    const liveStream = listEventLiveStream[key][index];
                    const disableCheckBox = liveStream.registered ? { color: '#00000042' } : { color: eventInfo?.settings_colors_viewer?.button_background_color?.common_button };
                    const dataLivestream = [
                        <Checkbox
                            checked={(registerCheck[liveStream.id] && registerCheck[liveStream.id][liveStream.id]) || liveStream.registered}
                            onChange={(e) => handleRegisterCheck(e, liveStream.id, liveStream.cost, liveStream.title)}
                            onClick={(e) => e.stopPropagation()}
                            style={disableCheckBox}
                        />,
                        `${liveStream.stime}~${liveStream.etime}`,
                        liveStream.title,
                        liveStream.content,
                        liveStream.speaker,
                        LIVESTREAM_STATUS_TEXT[locale][liveStream.status],
                        liveStream.cost === 0
                            ? intl.formatMessage({ id: 'common.free' })
                            : `${intl.formatNumber(liveStream.cost)}${intl.formatMessage({ id: 'common.yen' })}`,
                    ];
                    if (!isRegisterLivestreamAfter3day() && !liveStream.registered && !isRegisterLivestreamViewNew(key, liveStream.stime)) {
                        dataLivestream.shift();
                        dataLivestream.unshift('');
                    }
                    return dataLivestream;
                });
            } else {
                tableData = Object.keys(listEventLiveStream[key]).map((index) => {
                    const liveStream = listEventLiveStream[key][index];
                    return [
                        `${liveStream.stime}~${liveStream.etime}`,
                        liveStream.title,
                        liveStream.content,
                        liveStream.speaker,
                        liveStream.cost === 0
                            ? intl.formatMessage({ id: 'common.free' })
                            : `${intl.formatNumber(liveStream.cost)}${intl.formatMessage({ id: 'common.yen' })}`,
                    ];
                });
            }
            viewTable.push(createTable(key, tableData));
            const viewDate = (
                <React.Fragment key={key}>
                    {createDateTitle(key)}
                    {viewTable}
                </React.Fragment>
            );
            viewTotal.push(viewDate);
        })

        );
        return viewTotal;
    };

    const handleRegisterCheck = (e, id, cost, title) => {
        setRegisterCheck({ ...registerCheck, [id]: { [id]: e.target.checked, price: cost, titleLive: title } });
    };

    const createCustomLayout = () => (
        <ListLiveStreamViewerCustomLayout
            listData={listEventLiveStream}
            loggedIn={loggedIn}
            isWeakAuth={isWeakAuth}
            eventInfo={eventInfo}
            customColor={customColor}
            customText={customText}
            handleViewLiveStream={onViewLiveStream}
            isRegisterLivestreamView={isRegisterLivestreamViewNew}
            isRegisterLivestreamAfter3day={isRegisterLivestreamAfter3day}
            registerCheck={registerCheck}
            handleRegisterCheck={handleRegisterCheck}
            locale={locale}
        />
    );

    const createDateTitle = (dateTitle) => (
        <GridItem xs={12} style={{ margin: '20px 0 20px 0' }}>
            <CustomTypography bold variant="h5" customColor={customColor?.contents_text_color}>
                {intl.formatMessage({ id: 'common.date' })}
                {'  :  '}
                {dateUtils.formatJa(new Date(dateTitle), locale)}
            </CustomTypography>
        </GridItem>

    );

    const createTable = (key, viewlist) => {
        let tableHeader = [];
        let tableHeaderWidth = [];
        if (loggedIn && (!isWeakAuth || isWeakAuth === 'false') && !eventInfo.free_live_stream) {
            tableHeader = [
                customText?.field_name?.application_check || intl.formatMessage({ id: 'seminar.applicationCheck' }),
                customText?.field_name?.delivery_time || intl.formatMessage({ id: 'livestream.deliveryTime' }),
                customText?.field_name?.title || intl.formatMessage({ id: 'common.title' }),
                customText?.field_name?.contents || intl.formatMessage({ id: 'livestream.deliveryContent' }),
                customText?.field_name?.performer || intl.formatMessage({ id: 'common.performer' }),
                customText?.field_name?.situation || intl.formatMessage({ id: 'status' }),
                customText?.field_name?.fee || intl.formatMessage({ id: 'price' }),
            ];
            tableHeaderWidth = ['12%', '15%', '15%', '20%', '14%', '14%', '10%'];
        } else if (loggedIn && eventInfo.free_live_stream) {
            tableHeader = [
                customText?.field_name?.delivery_time || intl.formatMessage({ id: 'livestream.deliveryTime' }),
                customText?.field_name?.title || intl.formatMessage({ id: 'common.title' }),
                customText?.field_name?.contents || intl.formatMessage({ id: 'livestream.deliveryContent' }),
                customText?.field_name?.performer || intl.formatMessage({ id: 'common.performer' }),
                customText?.field_name?.fee || intl.formatMessage({ id: 'price' }),
                customText?.field_name?.watch_livestream_free || intl.formatMessage({ id: 'livestream.watchLivestream' }),
            ];
            tableHeaderWidth = ['15%', '15%', '22%', '18%', '10%', '20%'];
        } else {
            tableHeader = [
                customText?.field_name?.delivery_time || intl.formatMessage({ id: 'livestream.deliveryTime' }),
                customText?.field_name?.title || intl.formatMessage({ id: 'common.title' }),
                customText?.field_name?.contents || intl.formatMessage({ id: 'livestream.deliveryContent' }),
                customText?.field_name?.performer || intl.formatMessage({ id: 'common.performer' }),
                customText?.field_name?.fee || intl.formatMessage({ id: 'price' }),
            ];
            tableHeaderWidth = ['15%', '18%', '35%', '18%', '14%'];
        }
        return (
            <GridItem xs={12} key={key}>
                <CustomTable
                    cellTextColorHear={customColor?.list_table?.title_text_color}
                    cellTextColorBody={customColor?.contents_text_color}
                    cellBackgroundColor={customColor?.list_table}
                    tableHead={tableHeader}
                    tableHeadWidth={tableHeaderWidth}
                    tableData={viewlist}
                    cellColor={customColor?.list_table?.title_background_color || navyColor}
                    hover={false}
                />
            </GridItem>
        );
    };

    const onViewLiveStream = (e, id) => {
        const { pathname } = history.location;
        const path = `${pathname}/${id}`;
        history.push(path);
    };

    const handleRedirectRegisterVisitor = () => {
        const { shortName } = routeParams;
        history.push(`/${shortName}/register-visitor`);
    };

    const getRegisterId = () => {
        const total = [];
        Object.keys(registerCheck).forEach((id) => {
            if (registerCheck[id][id]) {
                total.push(+id);
            }
        });
        return total;
    };

    const getRegisterCost = () => {
        let totalPrice = 0;
        Object.keys(registerCheck).forEach((id) => {
            if (registerCheck[id][id]) {
                totalPrice += registerCheck[id].price;
            }
        });
        return totalPrice;
    };

    const handleShowConfirmDialog = () => {
        if (registerCheck && getRegisterId().length > 0) {
            if (getRegisterCost()) {
                setIsOpenConfirmDialog({
                    open: true,
                    content: eventInfo?.settings_texts_sidebar_viewer?.field_name?.livestreaming
                        ? intl.formatMessage({ id: 'seminar.register' })
                        : intl.formatMessage({ id: 'livestream.register' }, {
                            namePage: intl.formatMessage({ id: 'userRouters.liveStream' }).toLocaleLowerCase(),
                        }),
                });
            } else {
                setIsOpenConfirmDialog({
                    open: true,
                    content: eventInfo?.settings_texts_sidebar_viewer?.field_name?.livestreaming
                        ? intl.formatMessage({ id: 'seminar.register' })
                        : intl.formatMessage({ id: 'livestream.registerNext' }, {
                            namePage: intl.formatMessage({ id: 'userRouters.liveStream' }).toLocaleLowerCase(),
                        }),
                });
            }
        } else {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: intl.formatMessage({ id: 'seminar.selectLeast' }, {
                    name: eventInfo.settings_texts_sidebar_viewer?.field_name?.livestreaming
                    || intl.formatMessage({ id: 'userRoutes.liveStream' }).toLocaleLowerCase(),
                }),
            });
            handleCloseConfirmDialog();
        }
    };

    const registerLivestream = () => {
        if (!getRegisterCost()) {
            setIsOpenConfirmDialog({ open: false, content: '' });
            handlePaymentAndRegister();
        } else if (getRegisterId().length > 0 && getRegisterCost()) {
            setOpenDialogDetail(true);
            setIsOpenConfirmDialog({ open: false, content: '' });
        } else {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: intl.formatMessage({ id: 'seminar.selectLeast' }, {
                    name: eventInfo.settings_texts_sidebar_viewer?.field_name?.livestreaming
                    || intl.formatMessage({ id: 'userRoutes.liveStream' }).toLocaleLowerCase(),
                }),
            });
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    const handleCloseConfirmDialog = () => {
        setIsOpenConfirmDialog({ open: false, content: '' });
    };

    const handleCloseDialogDetail = () => {
        setOpenDialogDetail(false);
    };

    const handlePaymentAndRegister = () => {
        let dataSubmit;
        if (!getRegisterCost()) {
            dataSubmit = {
                live_stream_time_ids: getRegisterId(),
            };
            viewerRegisterLiveStream({
                data: dataSubmit,
                language: locale,
            });
        }
    };

    const handleSuccessDialog = () => {
        if (!isOpenConfirmSuccess.success) {
            setIsOpenConfirmSuccess({ open: false, content: '', success: false });
        } else {
            const { shortName } = routeParams;
            const cookies = new Cookies();
            cookies.set('tabSelect', 5, { path: '/' });
            history.push(`/${shortName}/live-stream-registered`);
        }
    };

    return (
        <div>
            <Loader isLoading={isLoading} />
            {!_.isEmpty(eventInfo) && (
                <>
                    <GridItem className={classNames({ [classes.noPadding]: platform !== PLATFORM.OTHER && eventInfo.layout_seminar })}>
                        {!eventInfo.layout_livestream ? createDataView() : createCustomLayout()}
                    </GridItem>
                    { currentPage < totalPage && (
                        <GridItem align={!loggedIn && !eventInfo.layout_livestream ? 'right' : 'center'} className={eventInfo.layout_livestream && classes.loadMore}>
                            <Button
                                onClick={handleSearchWithPage}
                                color="navy"
                                gradient
                                size="md"
                                round
                                buttonTextColor={customColor?.button_text_color}
                                buttonBackgroundColor={customColor?.button_background_color?.common_button}
                            >
                                <LoadMoreIcon />
                                {intl.formatMessage({ id: 'common.seeMore' })}
                            </Button>
                        </GridItem>
                    )}
                    {
                        !listEvent.total_length && (
                            <GridItem
                                xs={12}
                                style={{
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    fontSize: '20px',
                                    zIndex: 1,
                                    color: customColor?.contents_text_color,
                                }}
                            >
                                <FormattedMessage id="noData" />
                            </GridItem>
                        )
                    }
                    {
                        !loggedIn && isCheckEvent && !!(!eventInfo.free_seminar && !eventInfo.free_exhibition && !eventInfo.free_live_stream && !eventInfo.outer_server_activation) && (
                            <RegisterLinks />
                        )
                    }
                    <GridContainer style={{ marginTop: '20px' }}>
                        {
                            !loggedIn && eventInfo.free_live_stream && <FreeLogin customColor={customColor} />
                        }
                        {
                            (!loggedIn || (loggedIn && (isWeakAuth || isWeakAuth === 'true'))) && !eventInfo.free_live_stream
                            && !(!eventInfo.free_seminar && !eventInfo.free_exhibition && !eventInfo.free_live_stream)
                            && !eventInfo.outer_server_activation && (
                                <GridItem container item className={classes.sectionWrapper}>
                                    <GridItem xs={12} lg={6}>
                                        <div className={classes.centerToRight}>
                                            <Button
                                                color="info"
                                                gradient
                                                className={classes.buttonBig2}
                                                round
                                                onClick={handleRedirectRegisterVisitor}
                                                buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                                                buttonBackgroundColor={customColor?.button_background_color?.viewer}
                                            >
                                                {intl.formatMessage({ id: 'exhibition.apply' })}
                                            </Button>
                                        </div>
                                    </GridItem>
                                    <GridItem xs={12} lg={6}>
                                        <Box display="flex" className={classes.helperText}>
                                            <RadioButtonIcon color={customColor?.button_background_color?.viewer || '#4facfe'} />
                                            <CustomTypography variant="subtitle1" customColor={customColor?.contents_text_color}>
                                                {intl.formatMessage({ id: 'exhibition.noteRegister' }, {
                                                    exhibition: eventInfo.settings_texts_sidebar_viewer?.field_name?.livestreaming
                                                    || intl.formatMessage({ id: 'userRouters.liveStream' }),
                                                })}
                                            </CustomTypography>
                                        </Box>
                                    </GridItem>
                                </GridItem>
                            )
                        }
                    </GridContainer>
                    {(loggedIn && (!isWeakAuth || isWeakAuth === 'false') && listEvent.total_length && !eventInfo.free_live_stream) ? (
                        <GridContainer
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >
                            <Button
                                color="navy"
                                round
                                gradient
                                className={classes.buttonBig}
                                onClick={() => handleShowConfirmDialog()}
                                buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                                buttonBackgroundColor={customColor?.button_background_color?.common_button}
                            >
                                <b>
                                    {customText?.button_name?.livestream_viewing_application
                                    || intl.formatMessage({ id: 'registerViewer.applicationLivestream' })}
                                </b>
                            </Button>
                        </GridContainer>
                    ) : ''}
                    <LivestreamPayment
                        locate={locale}
                        openDialogDetail={openDialogDetail}
                        handleCloseDialogDetail={handleCloseDialogDetail}
                        registerCheck={registerCheck}
                        getRegisterCost={getRegisterCost()}
                        eventInfo={eventInfo}
                        viewerRegisterLiveStream={viewerRegisterLiveStream}
                        paymentMethod={(value) => setParams({ payment_method: value })}
                        getTokenError={(value) => setIsOpenConfirmSuccess({ open: true, content: value, success: false })}
                        customText={customText}
                        customColor={customColor}
                    />
                    <Snackbar
                        open={snackbar.isOpen}
                        onClose={handleCloseSnackbar}
                        message={snackbar.message}
                        severity={snackbar.type}
                    />
                    <AlertDialog
                        handleOpen={isOpenConfirmDialog.open}
                        handleClose={handleCloseConfirmDialog}
                        handleSubmit={registerLivestream}
                        contents={isOpenConfirmDialog.content}
                        customColor={customColor}
                    />
                    <ConfirmDialog
                        title={intl.formatMessage({ id: 'confirm' })}
                        contents={isOpenConfirmSuccess.content}
                        open={isOpenConfirmSuccess.open}
                        handleClose={handleSuccessDialog}
                        customColor={customColor}
                    />
                </>
            )}
        </div>
    );
};

ListLiveStreamViewer.defaultProps = {
    isLoading: false,
    listEvent: { },
    listDate: { },
    currentPage: null,
    totalPage: null,
    eventInfo: {},
    isWeakAuth: false || undefined,
    isCheckEvent: false,
    registerStatus: false,
    idRegister: {},
    viewerRegisterLiveStream: () => {},
    clearRegisterLiveStream: () => {},
    errorRegister: {},
    customText: {},
    customColor: {},
    errorRegisterLivestream: {},
    locale: 'ja',
};

ListLiveStreamViewer.propTypes = {
    isLoading: PropTypes.bool,
    currentPage: PropTypes.number,
    totalPage: PropTypes.number,
    listEvent: PropTypes.oneOfType([() => null, PropTypes.object]),
    listDate: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchViewerGetListLiveStream: PropTypes.func.isRequired,
    fetchViewerClearGetListLiveStream: PropTypes.func.isRequired,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    loggedIn: PropTypes.bool.isRequired,
    isWeakAuth: PropTypes.oneOfType([() => PropTypes.bool, PropTypes.string]),
    isCheckEvent: PropTypes.bool,
    registerStatus: PropTypes.bool,
    idRegister: PropTypes.oneOfType([() => null, PropTypes.object]),
    viewerRegisterLiveStream: PropTypes.func,
    clearRegisterLiveStream: PropTypes.func,
    errorRegister: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchViewerGetListLiveStreamLoginAcc: PropTypes.func.isRequired,
    ClearViewerGetListLiveStreamLoginAcc: PropTypes.func.isRequired,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    errorRegisterLivestream: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
};

export default ListLiveStreamViewer;
